module.exports = __webpack_public_path__ + "static/img/23.ae6c18e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/23.png
// module id = wlWn
// module chunks = 0